export default "__VITE_ASSET__e518baac__"